module.exports = __webpack_public_path__ + "img/question-visual-desktop.d50c709a.png";